import {
  useAuditEntityTypeNameTranslationSelector,
  useGetAuditInfoQuery,
} from '@/features/audit/auditApi';

export const useGetAvailableEntities = (entityTypeName: string) => {
  const { data: { availableEntities = [] } = {} } = useGetAuditInfoQuery(
    entityTypeName,
    { skip: !entityTypeName },
  );
  return availableEntities;
};

export const useGetEntityTypeName = (value: string) => {
  const auditEntityTypeNameTranslation =
    useAuditEntityTypeNameTranslationSelector();

  return auditEntityTypeNameTranslation[value] || value;
};
